import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-synopsis-popup',
  templateUrl: './synopsis-popup.component.html',
  styleUrls: ['./synopsis-popup.component.css'],
})
export class SynopsisPopupComponent {
  constructor(
    private dialogRef: MatDialogRef<SynopsisPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      id: string;
      title: string;
    },
    private snackbar: MatSnackBar,
    private api: ApiService
  ) {}

  buttonClicked: boolean = false;

  header: string = '';
  client: string = '';
  reportType: string = '';
  comment: string = '';
  clients = JSON.parse(sessionStorage.getItem('clients'));
  reportTypes: Array<string> = [];
  startDate : Date;
  endDate : Date;
  selectedType : string = ''
  fleetName : string = ''
  version : string = 'v02'
  versions: string[] = ['v01', 'v02'];

  ngOnInit() {
    this.getReportTypes();
    this.header = this.data.title;
    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  openCleanedLink(link: string) {
    const cleanedLink = link.endsWith('/') ? link.slice(0, -1) : link;
    window.open(cleanedLink);
  }

  getReportTypes() {
    this.api.getReportTypes().subscribe(
      (data: any) => {
        this.reportTypes = Object.keys(data);
      },
      (error) => {
        //   pass
      }
    );
  }

  download() {
    this.buttonClicked = true;
    if (this.data.id == 'summaryReport') {
      this.api.summaryReport({ comments: this.comment }).subscribe(
        (data: any) => {
          this.buttonClicked = false;
          if (data.status) {
            this.dialogRef.close(data.data.reportid);
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'success',
            });
            this.openCleanedLink(data.data.link);
          } else {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'failure',
            });
          }
        },
        (error) => {
          this.buttonClicked = false;
        }
      );
    } else if (this.data.id == 'clientEngagementReport') {
      this.api
        .clientEngagementReport({
          client: this.client,
          reportType: this.reportType,
          comments: this.comment,
        })
        .subscribe(
          (data: any) => {
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } else if (this.data.id == 'clientCapacityReport') {
      this.api
        .clientCapacityReport({
          client: this.client,
          comments: this.comment,
        })
        .subscribe(
          (data: any) => {
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } else if (this.data.id == 'statisticsReport') {
      this.api
        .statisticsReport({
          comments: this.comment,
        })
        .subscribe(
          (data: any) => {
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } else if (this.data.id == 'internalAdminPanel') {
      this.api
        .internalAdminPanel({
          startDate: this.startDate,
          endDate: this.endDate,
          comments: this.comment,
        })
        .subscribe(
          (data: any) => {
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } else if (this.data.id == 'psychologistReport') {
      this.api
        .psychologistReport({
          comments: this.comment,
        })
        .subscribe(
          (data: any) => {
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } else if (this.data.id == 'nutritionistReport') {
      this.api
        .nutritionistReport({
          comments: this.comment,
        })
        .subscribe(
          (data: any) => {
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
        
    }  
    else if (this.data.id == 'monthlyReport') {
      this.api
        .monthlyReport({
          client : this.client,
          startDate: this.startDate,
          endDate: this.endDate,
          comments: this.comment
        })
        .subscribe(
          (data: any) => {
            console.log(data);
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } else if (this.data.id == 'quarterlyReport') {
      this.api
        .quarterlyReport({
          client : this.client,
          type: this.selectedType,
          fleet: this.fleetName,
          startDate: this.startDate,
          endDate: this.endDate,
          comments: this.comment
        })
        .subscribe(
          (data: any) => {
            console.log(data);
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } else if (this.data.id == 'annuallyReport') {
      this.api
        .annuallyReport({
          client : this.client,
          type: this.selectedType,
          fleet: this.fleetName,
          startDate: this.startDate,
          endDate: this.endDate,
          version: this.version,
          comments: this.comment
        })
        .subscribe(
          (data: any) => {
            console.log(data);
            this.buttonClicked = false;
            if (data.status) {
              this.dialogRef.close(data.data.reportid);
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'success',
              });
              this.openCleanedLink(data.data.link);
            } else {
              this.snackbar.open(data.message, undefined, {
                duration: 5000,
                panelClass: 'failure',
              });
            }
          },
          (error) => {
            this.buttonClicked = false;
          }
        );
    } 
  }
}
